import { createGlobalStyle } from 'styled-components';

export const ClientNavigationNotificationStyles = createGlobalStyle`
  .ant-layout-sider-collapsed a[href='/documents'] .ant-badge {
    position: absolute;
    z-index: 1;
    top: 0;
    inset-inline-start: calc(50% - ${({ theme }) => theme.spacing.xs}px);
  }
`;
